export default __webpack_public_path__ + "static/media/L1D.abe24b08.png";